import React, {useState} from 'react';
import {PanelMenuContainer, PanelContentContainer, ActiveRoute} from "./panel-wrapper.styles";
import {Jumbotron} from "../../core-ui/jumbotron/jumbotron";
import {
    ProfileDropDownBadge,
    ProfileDropDownItem,
    ProfileDropDownItems
} from "../../core-ui/panel-menu/panel-menu-item.styles";
import {NavLink, useNavigate} from "react-router-dom";
import {PHARMA_TOK} from "../../helpers/general-variables";
import Notification from "../../helpers/notifications";
import {useDispatch} from "react-redux";
import {setLoginStatus} from "../../redux/user/user.action";
import {Modal} from "react-responsive-modal";
import {ShiftModalContainer} from "../../pages/Requests/requests.styles";

const PanelWrapper = ({children, activeRouteData = {icon: '', name: ''}}) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [logoutModal, setLogoutModal] = useState(false);

    const logout = () => {
        localStorage.removeItem(PHARMA_TOK);
        dispatch(setLoginStatus(false));
        setLogoutModal(false);
        Notification.warning('از حساب کاربری خود خارج شدید');
        navigate('/');
    }

    return (
        <>
            <div className='container-xxl rtl mt-3 mt-lg-5 bg-max-lg-darker'>
                <div className='d-lg-none'>
                    <ActiveRoute to='/panel' className='d-flex align-items-center justify-content-between'>
                        <div className='d-flex align-items-center'>
                            <i className={activeRouteData.icon} />
                            <p className='mb-0 me-3'>{activeRouteData.name}</p>
                        </div>
                        <i className='icon-arrow arrow' />
                    </ActiveRoute>
                </div>
                <Jumbotron className='d-flex px-c-lg-2 pt-3 max-md-no-shadow'>
                    <div className='d-flex flex-grow-1'>
                        <PanelMenuContainer className='d-none d-lg-block'>
                            <div>
                                <ProfileDropDownItems>
                                    <ProfileDropDownItem color='#6C8CBF'>
                                        <NavLink to='/panel/my-requests'>
                                            <i className='icon-people'/>
                                            <p>درخواست‌های من</p>
                                            <ProfileDropDownBadge/>
                                        </NavLink>
                                    </ProfileDropDownItem>
                                    <ProfileDropDownItem color='#6C8CBF'>
                                        <NavLink to='/panel/my-shifts'>
                                            <i className='icon-clipboard-tick-2'/>
                                            <p>شیفت های قبول شده</p>
                                            <ProfileDropDownBadge/>
                                        </NavLink>
                                    </ProfileDropDownItem>
                                    <ProfileDropDownItem color='#6C8CBF'>
                                        <NavLink to='/panel/my-account'>
                                            <i className='icon-personalcard'/>
                                            <p>اطلاعات حساب کاربری</p>
                                        </NavLink>
                                    </ProfileDropDownItem>
                                    <ProfileDropDownItem color='#6C8CBF'>
                                        <button onClick={() => setLogoutModal(true)}>
                                            <i className='icon-logout'/>
                                            <p>خروج از حساب کاربری</p>
                                        </button>
                                    </ProfileDropDownItem>
                                </ProfileDropDownItems>
                            </div>
                        </PanelMenuContainer>
                        <PanelContentContainer>
                            {children}
                        </PanelContentContainer>
                    </div>
                </Jumbotron>
            </div>


            <Modal open={logoutModal} onClose={() => setLogoutModal(false)}
                   classNames={{modal: 'c-modal-container c-modal-sw'}}
                   showCloseIcon={false} center>
                <ShiftModalContainer>
                    <div className='text-center mt-c-2'>
                        <p className='fs-c-3 danger-color'>آیا میخواهید از حساب کاربری خود خارج شوید؟</p>
                        <div className='d-flex align-items-center justify-content-center mt-5 mb-4'>
                            <button className='btn-text me-5' onClick={() => setLogoutModal(false)}>بازگشت به صفحه قبلی</button>
                            <button className='c-btn simple-btn-danger px-3' onClick={logout}>خروج از حساب کاربری</button>
                        </div>
                    </div>
                </ShiftModalContainer>
            </Modal>
        </>

    );
};

export default PanelWrapper;
